// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"calendar-3"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M21 10.5V5.5H3V10.5H21Z"}},{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21.5L21 21.5V10.5L3 10.5L3 21.5Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7 18H15M7 14H11","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 10.5V21.5H3V10.5M21 10.5H3M21 10.5V5.5H3V10.5M7 5.5V2.5M17 5.5V2.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Calendar3Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'calendar-3',
    ref,
    icon: element,
  },
));

Calendar3Icon.displayName = 'Calendar3Icon';

export default Calendar3Icon;
